import { Stack } from '@mui/material';
import { Dialog } from 'common/components';
import { WarningOutlinedIcon } from 'icons';

import { NavigationBar } from '../NavigationBar';

export const ErrorHandler = ({
  title = 'Oops, something went wrong...',
  description = 'Looks like there was some unexpected error.',
}: {
  title?: string;
  description?: string;
}) => (
  <>
    <NavigationBar disableUserSection />

    <Dialog isOpen title={title} showCloseButton={false} showCancelButton={false} centered>
      <Stack alignItems="center" gap={2}>
        <WarningOutlinedIcon fontSize="large" color="error" />
        <div>{description}</div>
        <div>
          Refresh the page or contact the Support Team{' '}
          <a href="https://intercom.help/natter/en/" target="_blank" rel="noreferrer">
            here
          </a>
          .
        </div>
      </Stack>
    </Dialog>
  </>
);
